<template>
  <div class="legal-page">
    <mPageTitle
      :title="$t('Politica de Confidențialitate')"
      :subtitle="$t('privacy_subtitle')"
      :description="$t('privacy_description')"
      :image="require('@/assets/images/webp/services.webp')"
    />

    <aSection :background="'#fff'">
      <div class="container legal-page__content">
        <div class="legal-page__last-updated">
          {{ $t("legal_last_updated") }}: 06.08.2026
        </div>

        <div class="legal-page__intro">
          <p class="legal-page__intro-service">{{ $t("legal_service") }}</p>
          <p class="legal-page__intro-company">{{ $t("legal_company") }}</p>
          <p class="legal-page__intro-note">{{ $t("privacy_intro_note") }}</p>
        </div>

        <section class="legal-page__section">
          <h2>{{ $t("privacy_s1_title") }}</h2>
          <ol class="legal-page__clauses" start="1">
            <li>{{ $t("privacy_c1") }}</li>
            <li>{{ $t("privacy_c2") }}</li>
          </ol>
          <div class="legal-page__cross-ref">
            <p>
              {{ $t("privacy_cross_ref") }}
              <router-link :to="termsPath">
                {{ $t("Termeni și Condiții") }}
              </router-link>
              .
            </p>
          </div>
        </section>

        <section class="legal-page__section">
          <h2>{{ $t("privacy_s2_title") }}</h2>
          <ol class="legal-page__clauses" start="3">
            <li>{{ $t("privacy_c3") }}</li>
            <li>{{ $t("privacy_c4") }}</li>
          </ol>
        </section>

        <section class="legal-page__section">
          <h2>{{ $t("privacy_s3_title") }}</h2>
          <ol class="legal-page__clauses" start="5">
            <li>{{ $t("privacy_c5") }}</li>
            <li>{{ $t("privacy_c6") }}</li>
            <li>{{ $t("privacy_c7") }}</li>
            <li>{{ $t("privacy_c8") }}</li>
          </ol>
        </section>

        <section class="legal-page__section">
          <h2>{{ $t("privacy_s4_title") }}</h2>
          <ol class="legal-page__clauses" start="9">
            <li>{{ $t("privacy_c9") }}</li>
            <li>{{ $t("privacy_c10") }}</li>
            <li>{{ $t("privacy_c11") }}</li>
          </ol>
        </section>

        <section class="legal-page__section">
          <h2>{{ $t("privacy_s5_title") }}</h2>
          <ol class="legal-page__clauses" start="12">
            <li>{{ $t("privacy_c12") }}</li>
            <li>{{ $t("privacy_c13") }}</li>
            <li>{{ $t("privacy_c14") }}</li>
          </ol>
        </section>

        <section class="legal-page__section">
          <h2>{{ $t("privacy_s6_title") }}</h2>
          <ol class="legal-page__clauses" start="15">
            <li>
              {{ $t("privacy_c15") }}
              <ul>
                <li>{{ $t("privacy_c15_li1") }}</li>
                <li>{{ $t("privacy_c15_li2") }}</li>
                <li>{{ $t("privacy_c15_li3") }}</li>
                <li>{{ $t("privacy_c15_li4") }}</li>
                <li>{{ $t("privacy_c15_li5") }}</li>
                <li>{{ $t("privacy_c15_li6") }}</li>
                <li>{{ $t("privacy_c15_li7") }}</li>
              </ul>
            </li>
            <li>
              {{ $t("privacy_c16_a") }}
              <a
                href="https://www.dataprotection.ro"
                target="_blank"
                rel="noopener noreferrer"
                >dataprotection.ro</a
              >{{ $t("privacy_c16_b") }}
              <a href="tel:+40318059211">0318 059 211</a>.
            </li>
          </ol>
        </section>

        <section class="legal-page__section">
          <h2>{{ $t("privacy_s7_title") }}</h2>
          <ol class="legal-page__clauses" start="17">
            <li>{{ $t("privacy_c17") }}</li>
          </ol>
        </section>

        <section class="legal-page__section">
          <h2>{{ $t("privacy_s8_title") }}</h2>
          <ol class="legal-page__clauses" start="18">
            <li>{{ $t("privacy_c18") }}</li>
          </ol>
        </section>

        <section class="legal-page__section">
          <h2>{{ $t("privacy_s9_title") }}</h2>
          <ol class="legal-page__clauses" start="19">
            <li>{{ $t("privacy_c19") }}</li>
          </ol>
        </section>

        <section class="legal-page__section">
          <h2>{{ $t("privacy_contact_title") }}</h2>
          <p>
            {{ $t("privacy_contact_p1") }}
            <a href="mailto:office@luxbrumalis.ro">office@luxbrumalis.ro</a>.
          </p>
        </section>
      </div>
    </aSection>
  </div>
</template>

<script>
import mPageTitle from "../components/molecules/m-page-title.vue";
import aSection from "../components/atoms/a-section.vue";

const BASE_URL = "https://jeffbrasov.ro";

export default {
  metaInfo() {
    const lang = this.$i18n.locale;
    const pageUrl = `${BASE_URL}/${lang}/politica-de-confidentialitate`;
    const breadcrumbSchema = {
      "@context": "https://schema.org",
      "@type": "BreadcrumbList",
      itemListElement: [
        {
          "@type": "ListItem",
          position: 1,
          name: this.$t("Acasă"),
          item: `${BASE_URL}/${lang}/`,
        },
        {
          "@type": "ListItem",
          position: 2,
          name: this.$t("Politica de Confidențialitate"),
          item: pageUrl,
        },
      ],
    };
    return {
      title: this.$t("seo_title_privacy"),
      meta: [
        { name: "description", content: this.$t("meta_desc_privacy") },
        {
          property: "og:title",
          content: `${this.$t("seo_title_privacy")} | Mr Jeff Brașov`,
        },
        { property: "og:description", content: this.$t("meta_desc_privacy") },
        { property: "og:url", content: pageUrl },
        { name: "robots", content: "noindex, follow" },
      ],
      link: [
        { rel: "canonical", href: pageUrl },
        {
          rel: "alternate",
          hreflang: "ro",
          href: `${BASE_URL}/ro/politica-de-confidentialitate`,
        },
        {
          rel: "alternate",
          hreflang: "en",
          href: `${BASE_URL}/en/politica-de-confidentialitate`,
        },
        {
          rel: "alternate",
          hreflang: "x-default",
          href: `${BASE_URL}/ro/politica-de-confidentialitate`,
        },
      ],
      script: [{ type: "application/ld+json", json: breadcrumbSchema }],
    };
  },
  components: {
    mPageTitle,
    aSection,
  },
  computed: {
    termsPath() {
      return `/${this.$i18n.locale}/termeni-si-conditii`;
    },
  },
  mounted() {
    window.scrollTo({ top: 0 });
  },
};
</script>

<style lang="scss" scoped>
@import "~@/assets/styles/legal-page.scss";
</style>
